module.exports = __webpack_public_path__ + "img/ammiraglio_min.96524820.jpeg";